import {
  WalletOperationSummaryItemResponse,
  WalletOperationsSummaryResponse,
} from "../../../domain/models/accounting/wallet-operations.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isNullableFiniteNumber = (value: unknown): value is number | null =>
  value === null || isFiniteNumber(value);

const isItem = (value: unknown): value is WalletOperationSummaryItemResponse =>
  isRecord(value) &&
  isFiniteNumber(value["idConcept"]) &&
  typeof value["conceptName"] === "string" &&
  isFiniteNumber(value["amount"]) &&
  isFiniteNumber(value["percentage"]) &&
  isNullableFiniteNumber(value["operationCount"]);

export function isWalletOperationsSummaryResponse(
  value: unknown,
): value is WalletOperationsSummaryResponse {
  return isRecord(value) &&
    isFiniteNumber(value["idCompany"]) &&
    isFiniteNumber(value["idAccountingDay"]) &&
    isFiniteNumber(value["idCurrency"]) &&
    isFiniteNumber(value["totalAmount"]) &&
    isFiniteNumber(value["netAmount"]) &&
    typeof value["updatedAt"] === "string" &&
    Array.isArray(value["items"]) &&
    value["items"].every(isItem) &&
    isFiniteNumber(value["limit"]) &&
    isFiniteNumber(value["offset"]) &&
    typeof value["hasNext"] === "boolean";
}
